import React, { useEffect, useState } from 'react';
import { getdata } from '../../util/global';
import AdminMessageLogTable from './AdminMessageLogTable';

export default function AdminMessageLog() {
  const [messagedata, setmessagedata] = useState<any[]>([]);
  const [subscriptiondata, setsubscriptiondata] = useState<any[]>([]);
  const [userdata, setuserdata] = useState<any[]>([]);

  const loaddata = async () => {
    const messages = await getdata({ filter: { datatype: 'messagequeuedata' } });
    const subscriptions = await getdata({ filter: { datatype: 'subscriptiondata' } });
    const users = await getdata({ filter: { datatype: 'appuser' } });

    setmessagedata(messages.reverse() || []);
    setsubscriptiondata(subscriptions || []);
    setuserdata(users || []);
  };

  useEffect(() => {
    loaddata();
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0 }}>Message Log</h3>
        <button className="btn btn-outline-secondary btn-sm" onClick={loaddata}>
          Refresh
        </button>
      </div>

      <div className="card shadow-sm p-3">
        <AdminMessageLogTable messagedata={messagedata} subscriptiondata={subscriptiondata} userdata={userdata} />
      </div>
    </div>
  );
}
